import { ReactNode } from 'react'
import Close from '@mui/icons-material/Close'

import BaseModal, { IBaseModalProps } from './BaseModal'
import DetailsModalActionBar from './DetailsModalActionBar'

interface IDetailsModalProps extends IBaseModalProps {
  title: ReactNode
  footer?: ReactNode
  headerClassName?: string
  titleClassName?: string
  disableClose?: boolean
}

/**
 * Template for "Details" modals with the distinct header
 *
 * @param props MUI Modal props + `close` function that modifies `open`
 * @returns MUI Modal with the distinct details modal header
 */
const DetailsModal = ({
  title,
  titleClassName = 'font-bold',
  headerClassName = 'flex items-center px-6 py-4 h-12',
  footer,
  className = 'max-h-96vh',
  disableClose = false,
  ...props
}: IDetailsModalProps) => {
  const closeModal = () => {
    if (disableClose) {
      return
    }

    props.close()
  }

  const FooterDOM = () => {
    if (footer != null) {
      return footer
    }

    return <DetailsModalActionBar cancel={closeModal} />
  }

  return (
    <BaseModal {...props} className='flex items-center justify-center'>
      <div
        className={[
          'flex flex-col rounded bg-white shadow-modal-box-shadow',
          className
        ].join(' ')}
      >
        <div className={headerClassName}>
          <h3 className={titleClassName}>{title}</h3>
          <div className='flex-1' />
          <button
            onClick={closeModal}
            title='close modal'
            disabled={disableClose}
            className={disableClose ? 'cursor-not-allowed opacity-50' : ''}
          >
            <Close fontSize='small' />
          </button>
        </div>
        {props.children}
        <FooterDOM />
      </div>
    </BaseModal>
  )
}

export default DetailsModal
